export default __webpack_public_path__ + "static/media/IMG-20240729-WA0019.b91e8b8e.jpg";